////////LIBRARY/////////
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import _, { isEqual } from 'lodash'
import moment from 'moment'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
///////COMPONENTS///////
import Modals from '../../../../components/Modals'
import Button from '../../../../components/Ui/Buttons'
import theme from '../../../../theme/theme'
import { TextModal } from '../../../../theme/GlobalCss'
import StringFormatter from '../../../../helpers/StringFormatter'
import { articleLifeManagerActionCreators } from '../../../../store/actions'
/////////ASSETS/////////
import Validation from '../../../../assets/icones/global/check.svg'
import Cancel from '../../../../assets/icones/global/close-white.svg'

/////////STYLED/////////
const ModalCancelDeactivateActionWrapper = styled.div``
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
const TextTopWrapper = styled.div`
	margin: 15px 0;
`
const TextModalWrapper = styled.div`
	width: 102%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 0;
`
const TextModalCustom = styled.div`
	padding: 0;
`
const TextModalRed = styled(TextModal)`
	color: ${(props) => props.theme.colors.error};
	font-weight: 900;
`
const TextModalWrapperBottom = styled(TextModalWrapper)`
	margin-bottom: 15px;
	display: flex;
	justify-content: flex-start;
`
/////////STYLED/////////
// [88]_d): CANCEL PROGRESSIVE DESACTIVATION

const ModalCancelDeactivateAction = (props) => {
	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleCancelDeactivateActionModal = () => {
		actionsArticleLifeManager.postCancelDeactivateAction(props.cancelDeactivateAction.item.header.id, 'cancelDeactivationAction')
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.cancelDeactivateAction.close()
	}, [articleLifeManager?.isUpdate])

	const article = `<span style="color: ${theme.colors.primary}" > [${props?.cancelDeactivateAction?.item?.header?.itemRefLabel}] </span>`
	const date = `<span style="color: ${theme.colors.primary}" > ${moment(props?.cancelDeactivateAction?.current?.dateToModify).format(
		'DD/MM/YYYY'
	)} </span>`
	let textReaproNotStart = StringFormatter.ResponseMessageParser(
		_.replace(translations['modal__itemRef__timeline_action_deactivation_progressive_cancel_message'], '\\n', '<br>'),
		[article, date]
	)
	let textReaproStart = StringFormatter.ResponseMessageParser(
		_.replace(translations['modal__itemRef__timeline_action_deactivation_progressive_cancel_inProgress_message_firstPart'], '\\n', '<br>'),
		[article, date]
	)
	const dateRestock = props?.cancelDeactivateAction?.current?.dateLimit

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModalCancelDeactivateActionWrapper>
			<Modals
				showModal={props.cancelDeactivateAction.show}
				closeModalHandler={props.cancelDeactivateAction.close}
				level="error"
				icon={true}
				title={translations['modal__itemRef__timeline_action_deactivation_progressive_cancel_title']}
				width={555}
			>
				{!dateRestock
					? translations &&
					  !isEqual(props.cancelDeactivateAction.item.header, {}) && (
							<>
								<TextTopWrapper>
									<TextModalWrapper>
										{<TextModalCustom dangerouslySetInnerHTML={{ __html: textReaproNotStart }} />}
									</TextModalWrapper>
								</TextTopWrapper>
								<TextModalWrapperBottom>
									<TextModalCustom>
										{translations['modal__itemRef__timeline_action_deactivation_progressive_cancel_confirmation']}
									</TextModalCustom>
								</TextModalWrapperBottom>
							</>
					  )
					: translations &&
					  !isEqual(props.cancelDeactivateAction.item.header, {}) && (
							<>
								<TextTopWrapper>
									<TextModalWrapper>{<TextModalCustom dangerouslySetInnerHTML={{ __html: textReaproStart }} />}</TextModalWrapper>
								</TextTopWrapper>
								<TextModalWrapperBottom>
									<TextModalCustom>
										{
											translations[
												'modal__itemRef__timeline_action_deactivation_progressive_cancel_inProgress_message_secondPart'
											]
										}
									</TextModalCustom>
								</TextModalWrapperBottom>
								<TextModalWrapperBottom>
									<TextModalCustom>
										{translations['modal__itemRef__timeline_action_deactivation_progressive_cancel_confirmation']}
									</TextModalCustom>
								</TextModalWrapperBottom>
								<TextModalWrapperBottom>
									<TextModalRed>
										{translations['modal__itemRef__timeline_action_deactivation_progressive_cancel_inProgress_message_thirdPart']}
									</TextModalRed>
								</TextModalWrapperBottom>
							</>
					  )}

				<ButtonWrapper>
					<Button
						actionHandler={props.cancelDeactivateAction.close}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleCancelDeactivateActionModal()}
						text={translations['page__itemRef__timeline_action_deactivation_progressive_cancel']}
						bgColor={theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
		</ModalCancelDeactivateActionWrapper>
	)
}

ModalCancelDeactivateAction.propTypes = {}

ModalCancelDeactivateAction.defaultPropTypes = {}

export default ModalCancelDeactivateAction
